<template>
  <div>
    <div
      class="content-box"
      :class="
        property_data.show_fix == 2 && isEditorStatus === false
          ? 'box-fixed'
          : ''
      "
    >
      <div class="tms-form">
        <template v-if="form_list">
          <van-form ref="tmsForm" @submit="submitData">
            <div v-for="(item, index) in form_list" :key="index">
              <div
                class="tms-title"
                v-if="[1, 2, 3, 8, 11].includes(item.type) && !item.link"
              >
                {{ item.name }}
              </div>
              <van-radio-group
                @change="checkData"
                v-if="item.type == 1"
                v-model="item.value"
              >
                <van-radio
                  v-for="(name, x) in item.option_list"
                  :key="x"
                  :name="name"
                  checked-color="#FF6000"
                >
                  <span v-if="item.link && name.indexOf('《') > -1" class="agreement">
                    {{ name.split("《")[0]
                    }}<a v-if="item.link" :href="item.link">{{
                      name.match("\《([^》]+)\》").length
                        ? name.match("\《([^》]+)\》")[0]
                        : ""
                    }}</a
                    >{{ name.split("》")[1] }}
                  </span>
                  <span v-else>{{ name }}</span>
                </van-radio>
              </van-radio-group>

              <van-checkbox-group
                v-else-if="item.type == 2"
                v-model="item.value"
                @change="checkData"
              >
                <van-checkbox
                  v-for="(name, x) in item.option_list"
                  :key="x"
                  :name="name"
                  class="form-van-checkbox"
                  shape="square"
                  checked-color="#FF6000"
                  >{{ name }}</van-checkbox
                >
              </van-checkbox-group>

              <van-field
                class="form-text"
                v-if="[3, 8, 11].includes(item.type)"
                v-model="item.value"
                @blur="checkData"
                :name="item.name"
                :type="arrTexts[item.type].type"
                :placeholder="'请填写' + item.name"
                :maxlength="item.word_num_limit || 9999"
                :rules="[
                  {
                    required: !!Number(item.is_required),
                    message: '请填写' + item.name,
                  },
                ]"
              />
            </div>

            <div style="margin: 12px 6px 6px">
              <van-button
                round
                block
                :color="property_data.button_color"
                type="info"
                native-type="submit"
                >{{ property_data.button_name }}</van-button
              >
            </div>
          </van-form>
        </template>
        <div v-else class="def">请选择表单</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bridge } from "@mk/bridge";
const arrTexts = [
  { type: "text" },
  { type: "text" },
  { type: "text" },
  { type: "text" },
  { type: "dateDay" },
  { type: "dateTime" },
  { type: "area" },
  { type: "text" },
  { type: "tel" },
  { type: "number" },
  { type: "digit" },
  { type: "number" },
];

export default {
  name: "tms-form",
  props: ["config", "isEditorStatus"],

  data() {
    return {
      arrTexts,
      validatorStatus: false,
      isPadding: false,
    };
  },
  components: {},
  created() {
    if (
      navigator.userAgent.indexOf("Mockuai") >= 0 ||
      navigator.userAgent.indexOf("Wdzg") >= 0
    ) {
      const bridge = new Bridge();
      bridge.ready((apis, bridge, env) => {
        bridge.callHandler("getUserInfo", {}, (res) => {
          if (res && res.data) {
            lib.storage.set("user", res.data);
          }
        });
      });
    }
  },
  methods: {
    checkData(e, allowTips = false) {
      if (this.form_list.length) {
        for (var i = 0; i < this.form_list.length; i++) {
          if (this.form_list[i].is_required == 1 && !this.form_list[i].value) {
            if (allowTips) {
              this.$toast(
                `${this.form_list[i].name}${
                  this.form_list[i].type == 1 ? "未选择" : "未填写"
                }!`
              );
            }
            this.validatorStatus = false;
            break;
          }
          this.validatorStatus = true;
        }
      } else {
        this.validatorStatus = true;
      }
    },
    submitData() {
      if (this.isEditorStatus) {
        return;
      } else {
        this.checkData("", true);
        if (!this.validatorStatus || this.isPadding) {
          return;
        }
        this.isPadding = true;
        let formData = {
          submit_user_id: (lib.storage.get("user") || {}).userId || "",
          submit_user_name: (lib.storage.get("user") || {}).name || "",
          submit_time: new Date().getTime(),
          form_name: this.config.link_name,
          form_id: this.config.link_form_id,
          form_item_list: [],
        };
        for (let i in this.form_list) {
          if (this.form_list[i].value) {
            formData.form_item_list.push({
              name: this.form_list[i].name,
              value: this.form_list[i].value,
            });
          }
        }
        formData.form_item_list = JSON.stringify(formData.form_item_list);
        lib.tmsapi.post({
          api: "api/test/form_data/add",
          data: formData,
          success: (data) => {
            this.$toast(this.property_data.success_text || "提交成功！");
            this.isPadding = false;
          },
          error: (data) => {
            this.isPadding = false;
            if (data && data.code == 30000) {
              this.$toast(data.msg || "提交失败！");
            } else {
              this.$toast(this.property_data.success_text || "提交成功！");
            }
          },
        });
      }
    },
  },
  computed: {
    form_list() {
      if (this.config.link_data) {
        return this.config.link_data.form_item_list;
      } else {
        return false;
      }
    },
    property_data() {
      return this.config.property_data;
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>